var React = require('react');

function ShoppingBagFilled (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"shopping-bag"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"shopping-bag","fill":"#000000","fillRule":"nonzero"},React.createElement("path",{"d":"M13,6 L13,4 C13,1.791 11.209,0 9,0 C6.791,0 5,1.791 5,4 L5,6 L0,6 L0,24 L18,24 L18,6 L13,6 Z M6,4 C6,2.346 7.346,1 9,1 C10.654,1 12,2.346 12,4 L12,6 L6,6 L6,4 Z","id":"Shape"})))]);
}

ShoppingBagFilled.defaultProps = {"width":"18px","height":"24px","viewBox":"0 0 18 24","version":"1.1"};

module.exports = ShoppingBagFilled;

ShoppingBagFilled.default = ShoppingBagFilled;
